import { IDType } from '@core/models/types';
import { EntityLike } from '@entities/models';

export interface WizardItemEntity extends EntityLike {
  id: IDType;
  name: string;
  label: string;
  items: WizardItemEntity[];
  imageSrc: string;
  isColumn: boolean;
  comment: string;
  timeStamp: number;
  /* @task #5773
  ui: WizardItemUI
  identity: WizardItemIdentity
  */
}

export const isWizardItemEntity = <S extends {}>(entity: S): boolean => {
  return !!entity && (
    'label' in entity
    && 'items' in entity
    && 'imageSrc' in entity
    && 'isColumn' in entity
  );
};
